import { Box, Table, TableRow, TopBar } from '@sam/components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { convertDunningLevelsIntoTableEntries } from '../../utils/dunningLevel/DunningLevel.utils';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useUser } from '../../components/UserContext';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const DunningLevelOverview: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { axios, updateContextUser, user } = useUser();
  const { data: loadedDunningLevels } = useData('DUNNING_ALL', {
    config: { fallbackData: [] },
  });

  /**
   * TableRows containing different dunningLevels
   */
  const dunningRows: TableRow[] = useMemo((): TableRow[] => {
    if (!loadedDunningLevels) return [];
    return convertDunningLevelsIntoTableEntries(loadedDunningLevels, navigate);
  }, [loadedDunningLevels, navigate]);

  return (
    <>
      <TopBar title={t('pages.dunning.overview.topBarHeadline')}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('/dunning/edit')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.DUNNING_LEVEL_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.DUNNING_LEVEL_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          rows={dunningRows}
          header={
            t('pages.dunning.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
